import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import IpadAd from '../../../components/ipadAd';

class HFNewsSider extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { pfNewsSiderAd, ipadAd2 },
        } = this.props;

        return (
            <div className={styles.sider_box}>
                {pfNewsSiderAd ? (
                    <Ad content={pfNewsSiderAd} styleName={styles.sider} />
                ) : (
                    <div className={styles.ipad_sider}>
                        <Chip id="40104" type="static" title="广告3" groupName="房产美食要闻区左侧栏" content={ipadAd2}>
                            <IpadAd />
                        </Chip>
                    </div>
                )}
            </div>
        );
    }
}

export default errorBoundary(HFNewsSider);
